import { VOICE_COMMANDS } from "../constants/app.constants";

/**
 * Check if the given text contains the word "stop" as a standalone word
 */
export function isStopCommand(text: string): boolean {
  const trimmed = text.trim().toLowerCase();
  // Match "stop" as a whole word (with word boundaries) optionally followed by punctuation
  const stopRegex = /\bstop\b\.?/;
  return stopRegex.test(trimmed);
}

/**
 * Check if text is EXACTLY "stop" or "stop." with no other words
 */
export function isExactStopCommand(text: string): boolean {
  const trimmed = text.trim().toLowerCase();
  return trimmed === VOICE_COMMANDS.STOP || trimmed === VOICE_COMMANDS.STOP_WITH_PERIOD;
}

/**
 * Check if text should be displayed
 */
export function filterStopCommand(text: string): string {
  if (isExactStopCommand(text)) {
    return "";
  }
  return text;
}
